<template>
<div class="form-viewer">
    <div v-if="rf_debug">sw-form-viewer:{{ JSON.stringify(props.data_info,null,2) }} </div>
    <template v-for="(item_info) in sorted_data_info" v-bind:key="item_info.uuid">
        <sw-item-viewer
            :item_info="item_info"
            :view_mode="props.view_mode"
            :bottom_line="props.bottom_line"
            :text_align="props.text_align"
            :demo_mode="props.demo_mode"
            :form_info="props.form_info"
        />
    </template>
</div>
</template>

<script setup >
import { ref,onBeforeMount,defineProps,defineExpose } from 'vue';
import SwItemViewer from "./sw-item-viewer.vue"

// -----------------------------------------------
// v-modelに親コンポーネントで定義したデータ（ref/reactive）を指定する際に使用
// -----------------------------------------------

// -----------------------------------------------
// 親コンポーネントから子コンポーネントへデータを受け渡す
// -----------------------------------------------
const props = defineProps({
    // フォーム情報
    data_info: {
        type: Array,
        required: false,
        default: () => [],
    },
    view_mode : {
        type: String,
        required: false,
        default: "stacked", // "stacked","lined", 
    },
    bottom_line : {
        type: Boolean,
        required: false,
        default: false,
    },
    text_align: {
        type: String,
        required: false,
        default: "left", // "left","right", 
    },
    demo_mode : {
        type: Boolean,
        required: false,
        default: false,
    },
    // フォーム情報
    form_info: {
        type: Array,
        required: false,
        default: () => [],
    },
});
// -----------------------------------------------
// ローカル変数
// -----------------------------------------------
// デバッグ用
const rf_debug = ref(false)
// ブラウザからデフォルトの言語を取得する
//let locale = navigator.language;
//if( locale != "ja" && locale != "en" ) locale = "en";
let sorted_data_info = []

// -----------------------------------------------
// 既定計算 computed(() => {})
// -----------------------------------------------
// const state_xxxxx = computed(() => { return true or false; });
// -----------------------------------------------
// 監視
// -----------------------------------------------
// watch( rf_item_input, () => {});
// -----------------------------------------------
// コンポーネントがマウントされる直前に呼び出されるフックを登録します。
// -----------------------------------------------
onBeforeMount(() => {
    sorted_data_info = props.data_info
    //console.log("sw-form-viewer:onBeforeMount:sorted_data_info="+sorted_data_info)
    if( sorted_data_info !== null ){
        // exclude_item 指定の時
        let exclude_num = [];
        for( let i=0;i<sorted_data_info.length;i++ ){
            if( sorted_data_info[i].exclude_item !== undefined ){
                if( sorted_data_info[i].exclude_item ){
                    exclude_num.push(i);
                }
            }
        }
        for( let i=exclude_num.length-1;i>=0;i-- ){
            sorted_data_info.splice(exclude_num[i],1);
        }
        sorted_data_info.sort((a,b) => a.sequence - b.sequence)
        //console.log("onBeforeMount:sorted_data_info="+JSON.stringify(sorted_data_info,null,2))
    }
})
// -----------------------------------------------
// コンポーネントがマウントされた後に呼び出されるコールバックを登録します。
// -----------------------------------------------
// onMounted(() => {})
// -----------------------------------------------
// コンポーネントがリアクティブな状態変更により DOM ツリーを更新しようとする直前に呼び出されるフックを登録します。
// -----------------------------------------------
// onBeforeUpdate() => {})
// -----------------------------------------------
// コンポーネントがリアクティブな状態変更によって DOM ツリーを更新した後に呼び出されるコールバックを登録します。
// -----------------------------------------------
// onUpdated(() => {});
// -----------------------------------------------
// コンポーネントインスタンスがアンマウントされる直前に呼び出されるフックを登録します。
// -----------------------------------------------
// onBeforeUnmount(() => {})
// -----------------------------------------------
// コンポーネントがアンマウントされた後に呼び出されるコールバックを登録します。
// -----------------------------------------------
// onUnmounted(() => {})
// -----------------------------------------------
// 子孫コンポーネントから伝搬するエラーをキャプチャーしたときに呼び出されるフックを登録します。
// -----------------------------------------------
// onErrorCaptured(() => {})
    
// -----------------------------------------------
// ローカル関数
// -----------------------------------------------
const set_exclude_item_by_item_uuid = (item_uuid) => {
    for( let j=0;j<sorted_data_info.length;j++ ){
        if( sorted_data_info[j].uuid == item_uuid ){
            sorted_data_info[j].exclude_item = true;
        }
    }
}
const set_exclude_item_by_item_key = (item_key) => {
    for( let j=0;j<sorted_data_info.length;j++ ){
        if( sorted_data_info[j].key == item_key ){
            sorted_data_info[j].exclude_item = true;
        }
    }
}
defineExpose({
    set_exclude_item_by_item_uuid,
    set_exclude_item_by_item_key
});
</script>

<style scoped>
.form-viewer {
  text-align: left;
  margin: 0px;
  padding: 4px;
}
</style>
  